import {
  Dashboard,
  Ballot,
  HowToVote,
  Email,
  VerifiedUser,
} from "@material-ui/icons"
import GroupIcon from "@material-ui/icons/Group"

export const getDirectivaSections = () => [
  {
    id: "directiva",
    items: [
      {
        id: "dashboard",
        title: "Dashboard",
        icon: Dashboard,
        href: "/directiva/dashboard",
      },
      {
        id: "residentes",
        title: "Residentes",
        icon: GroupIcon,
        href: "/directiva/residentes",
      },
      {
        id: "access_controls",
        title: "Controles de acceso",
        icon: VerifiedUser,
        items: [
          { id: "placas", title: "Placas", href: "/directiva/placas" },
          { id: "tags", title: "Tags vehiculares", href: "/directiva/tags" },
        ],
      },
      {
        id: "notificaciones",
        title: "Notificaciones",
        icon: Email,
        href: "/directiva/notificaciones",
      },
      {
        id: "votacion",
        title: "Votación",
        icon: HowToVote,
        href: "/directiva/votacion",
      },
      {
        id: "reportes",
        title: "Reportes",
        icon: Ballot,
        items: [
          {
            id: "reporte_ingvsegr",
            title: "Ingresos y Egresos",
            href: "/directiva/reportes/ingvsegr",
          },
          {
            id: "reporte_cuentasporcobrar",
            title: "Cuentas por Cobrar",
            href: "/directiva/reportes/cuentasporcobrar",
          },
          {
            id: "reporte_ingresos",
            title: "Ingresos",
            href: "/directiva/reportes/ingresos",
          },
          {
            id: "reporte_egresos",
            title: "Egresos",
            href: "/directiva/reportes/egresos",
          },
          {
            id: "reporte_cartera",
            title: "Cartera Vencida",
            href: "/directiva/reportes/cartera",
          },
          {
            id: "reporte_cartera_usuario",
            title: "Cartera Mensualizada",
            href: "/directiva/reportes/carteraUsuario",
          },
          {
            id: "reporte_historico_cartera",
            title: "Historico de Cartera",
            href: "/directiva/reportes/historicoCartera",
          },
          {
            id: "reporte_consolidado",
            title: "Consolidado",
            href: "/directiva/reportes/consolidado",
          },
          {
            id: "reporte_financiero",
            title: "Financiero",
            href: "/directiva/reportes/financiero",
          },
        ],
      },
    ],
  },
]
